import { Box, Typography } from '@mui/material';
import DOMPurify from 'dompurify';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { useStore } from '@stores';

export const Copyright = observer(() => {
  const {
    partnerStore: { legalTerms },
  } = useStore();
  const current_year = new Date().getFullYear();
  const { t } = useTranslation('common');

  return (
    <Box display="flex">
      <Typography
        fontWeight={400}
        lineHeight="1"
        fontSize="0.625rem"
        color="#464646"
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(
            `© ${current_year} ${legalTerms?.copyright ?? ''}${t('copyright')}`
          ),
        }}
      />
    </Box>
  );
});
